import React from 'react';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { ColumnSizing } from '../tables-context';
import { getFormattedDate } from '../../../utils/utilities';
import { IApiClientCustomKeys } from '../../api-client-context';

export enum ApiClientTableAccessorKeys {
	// name = 'name',
	token = 'value',
	description = 'description',
	lastUsedDate = 'lastUsed',
	// createdOnDate = 'createdOnDate',
}

export const defaultApiClientsColumnSizing: ColumnSizing = {
	// [ApiClientTableAccessorKeys.name]: 100,
	[ApiClientTableAccessorKeys.description]: 100,
	// [ApiClientTableAccessorKeys.token]: 100,
	[ApiClientTableAccessorKeys.lastUsedDate]: 100,
	// [ApiClientTableAccessorKeys.createdOnDate]: 100,
};

export const defaultApiClientsColumns: MRT_ColumnDef<IApiClientCustomKeys>[] = [
	// @ts-ignore
	{
		accessorKey: ApiClientTableAccessorKeys.description,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<div className="fs-7 fc-text-overflow table-row-paddings">
					{renderedCellValue ? renderedCellValue : '-'}
				</div>
			</TableCell>
		)
	},
	// {
	// 	accessorKey: ApiClientTableAccessorKeys.token,
	// 	header: 'Token',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Token</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => {
	// 		const hiddenToken = renderedCellValue.slice(0,4) + '...' + renderedCellValue.slice(-3);
	// 		return (
	// 			<TableCell
	// 				additionalClass="d-flex align-items-center main-font-family text-black"
	// 				density={table?.options?.state?.density}
	// 				isTextOverflow={true}
	// 			>
	// 				<div className="fs-7 fc-text-overflow ms-2">
	// 					{renderedCellValue ? hiddenToken : '-'}
	// 				</div>
	// 			</TableCell>
	// 		);
	// 	}
	// },
	// {
	// 	accessorKey: ApiClientTableAccessorKeys.description,
	// 	header: 'Description',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Description</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="d-flex align-items-center main-font-family text-black"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={true}
	// 		>
	// 			<div className="fs-7 fc-text-overflow ms-2">
	// 				{renderedCellValue ? renderedCellValue : '-'}
	// 			</div>
	// 		</TableCell>
	// 	)
	// },
	{
		accessorKey: ApiClientTableAccessorKeys.lastUsedDate,
		header: 'Last used',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Last used</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const year = new Date(renderedCellValue).getFullYear();
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black"
					density={table?.options?.state?.density}
					isTextOverflow={false}
				>
					<div className="fs-8">
						{year === 1
							? '-'
							: getFormattedDate(renderedCellValue, 'dd MMM, yyyy')
						}
					</div>
				</TableCell>
			);
		}
	},
	// {
	// 	accessorKey: ApiClientTableAccessorKeys.createdOnDate,
	// 	header: 'Created',
	// 	enableSorting: false,
	// 	Header: <span className="text-muted fw-bolder main-font-family">Created</span>,
	// 	Cell: ({ renderedCellValue, table }: any): JSX.Element => (
	// 		<TableCell
	// 			additionalClass="d-flex align-items-center main-font-family text-black"
	// 			density={table?.options?.state?.density}
	// 			isTextOverflow={false}
	// 		>
	// 			<div className="fs-8">
	// 				{getFormattedDate(renderedCellValue, 'dd MMM, yyyy')}
	// 			</div>
	// 		</TableCell>
	// 	)
	// },
];
